import _ from 'lodash';
import Moment from 'moment';

import type { Policy } from '../../../accounts/summary/types/policy.types';
import {
  downloadPolicyDocuments,
  downloadReceipt,
  downloadInvoice,
  downloadPaymentPlan,
} from '../../../../policies/PolicyService';
import { downloadQuoteDocuments } from '../../../../inbox/QuotesService';

import { Modal } from '../../../../components/modals/v2/helpers/v2.modal.helpers';
import { DownloadEmailCertificateConfig } from '../../../../components/modals/DownloadEmailCertificate';

import { useDocumentDownload } from '../../../../utils/documents.utils';
import { DeletePolicyConfig } from '../../../../policies/DeletePolicy';
import { BrokerLossRunsModalConfig } from '../../../../components/modals/v2/BrokerLossRunsModal';

export const useAgencyPoliciesOptionHandlers = (data: Policy) => {
  const downloadDocument = useDocumentDownload();

  const accountId = _.get(data, 'accountId');
  const policyId = _.get(data, 'id');
  const policyNumber = _.get(data, 'policyNumber', '');
  const name = _.get(data, 'companyName');
  const created = Moment(_.get(data, 'created')).unix();
  const boundOn = _.get(data, 'boundOn');
  const isEndorsement = _.get(data, 'isEndorsement', false);
  const quoteId = _.get(data, 'quoteId');
  const companyName = _.get(data, 'companyName');
  const product = _.get(data, 'product');
  const quoteNumber = _.get(data, 'quoteNumber');

  const handleDownloadDocs = () => {
    downloadDocument({
      asyncDownload: () =>
        downloadPolicyDocuments(
          accountId,
          policyId,
          created,
          isEndorsement,
          product,
          policyNumber
        ),
      blobFileParams: {
        docName: `${name}-${policyNumber}-Cowbell-Policy`,
      },
    });
  };

  const handleDownloadReceipt = () => {
    downloadDocument({
      asyncDownload: () =>
        downloadReceipt(accountId, policyId, created, isEndorsement),
      blobFileParams: {
        docName: `${policyNumber}-Cowbell-Receipt`,
      },
    });
  };

  const handleDownloadInvoice = () => {
    downloadDocument({
      asyncDownload: () =>
        downloadInvoice(accountId, policyId, created, true, isEndorsement),
      blobFileParams: {
        docName: `${policyNumber}-Cowbell-Invoice`,
      },
    });
  };

  const handleDownloadPlan = () => {
    downloadDocument({
      asyncDownload: () =>
        downloadPaymentPlan(accountId, policyId, created, isEndorsement),
      blobFileParams: {
        docName: `${policyNumber}-Cowbell-FinancingAgreement`,
      },
    });
  };

  const handleDownloadApplication = () => {
    downloadDocument({
      asyncDownload: () =>
        downloadQuoteDocuments(
          accountId,
          quoteId,
          Moment(boundOn).unix(),
          isEndorsement,
          product,
          quoteNumber
        ),
      blobFileParams: {
        docName: `${companyName}-${policyNumber}-Cowbell-Application`,
      },
    });
  };

  const downloadEmailCertificate = () => {
    Modal.show(DownloadEmailCertificateConfig, { data });
  };

  const enterDeleteModal = () => {
    Modal.show(DeletePolicyConfig, {
      data,
      config: { title: `Delete Policy# ${_.get(data, 'policyNumber')}` },
    });
  };

  const handleLossRunsClick = () => {
    Modal.show(BrokerLossRunsModalConfig, {
      data,
    });
  };

  return {
    handleDownloadDocs,
    handleDownloadReceipt,
    handleDownloadInvoice,
    handleDownloadPlan,
    handleDownloadApplication,
    downloadEmailCertificate,
    enterDeleteModal,
    handleLossRunsClick,
  };
};
